module.exports = __webpack_public_path__ + "img/teamtailor.8630c421.png";